import './ClientInfo.css'
import React, {useEffect, useState} from "react";
import {useGetClientByUniqueCode} from "../../hooks/Administrative/useGetClientByUniqueCode";
import {Bounce, toast} from "react-toastify";
import {useUpdateClient} from "../../hooks/Administrative/useUpdateClient";
import PlantsView from "../PlantsView/PlantsView";
import NestedTableView from "../NestedTableView/NestedTableView";
import {useGetTickets} from "../../hooks/Administrative/useGetTickets";
import NestedEquipmentView from "../NestedEquipmentView/NestedEquipmentView";

const stateOptions = [
    {value: 'ACTIVE', label: 'Activo'},
    {value: 'DISABLED', label: 'Deshabilitado'},
    {value: 'BLOCKED', label: 'Bloqueado'}
];

const columns = ['PLANTA', 'SERVICIO', 'ESTADO', 'CLAVE DE TICKET'];


const ClientInfo = ({clientUniqueCode, onBack, additionalInfo}: {
    clientUniqueCode: string;
    onBack: () => void;
    additionalInfo: any;
}) => {

    const {client} = useGetClientByUniqueCode(clientUniqueCode);
    const [localName, setLocalName] = useState("");
    const [localEmail, setLocalEmail] = useState("");
    const [localUniqueCode, setLocalUniqueCode] = useState("");
    const [localTaxAddress, setLocalTaxAddress] = useState("");
    const [localMainPhone, setLocalMainPhone] = useState("");
    const [localSecondaryPhone, setLocalSecondaryPhone] = useState("");
    const [localState, setLocalState] = useState("");
    const [editDisabled, setEditDisabled] = useState(true);
    const {updateClient, updatingClient} = useUpdateClient();
    const [showPlants, setShowPlants] = useState(false);
    const [showTickets, setShowTickets] = useState(false);
    const [showEquipments, setShowEquipments] = useState(false);

    const [filters, setFilters] = useState({clientId: additionalInfo['ID']});
    const {tickets, totalPages, isLoading, page, setPage} = useGetTickets({filters});

    const handlePlantsClick = () => {
        setShowTickets(false);
        setShowEquipments(false);
        setShowPlants(true);
    }

    const handleTicketsClick = () => {
        setShowPlants(false);
        setShowEquipments(false);
        setShowTickets(true);
    }

    const handleEquipmentsClick = () => {
        setShowPlants(false);
        setShowTickets(false);
        setShowEquipments(true)
    }

    useEffect(() => {
        if (client) {
            setLocalName(client.name || "");
            setLocalEmail(client.email || "");
            setLocalUniqueCode(client.uniqueCode || "");
            setLocalTaxAddress(client.taxAddress || "");
            setLocalMainPhone(client.mainPhone || "");
            setLocalSecondaryPhone(client.secondaryPhone || "");
            setLocalState(client.clientState || "");
        }
    }, [client]);

    const exitPlantsView = () => {
        setShowPlants(false);
    }

    const existTicketsView = () => {
        setShowTickets(false);
    }

    const exitEquipmentView = () => {
        setShowEquipments(false);
    }

    const validateField = (field: any, regex: any, errorMessage: any) => {
        if (!regex.test(field)) {
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return false;
        }
        return true;
    };

    const handleClientUpdate = () => {

        if (!validateField(localName, /^.{1,150}$/, "El nombre del cliente no puede exceder los 150 caracteres ni estar vacío.")) return;
        //if (!validateField(localEmail, /^[^\s@]+@[^\s@]+\.[^\s@]+$/, "El formato del correo electrónico no es válido.")) return;
        if (localMainPhone && !validateField(localMainPhone, /^[+]?[0-9]{10,15}$/, "El teléfono principal no es válido.")) return;
        if (localSecondaryPhone && !validateField(localSecondaryPhone, /^[+]?[0-9]{10,15}$/, "El teléfono secundario no es válido.")) return;
        //if (!validateField(localTaxAddress, /^.{1,200}$/, "La dirección del cliente no puede exceder los 200 caracteres ni estar vacía.")) return;

        const clientDto = {
            id: client.id,
            uniqueCode: client.uniqueCode,
            email: localEmail.trim() === "" ? null : localEmail.trim(),
            name: localName,
            taxAddress: localTaxAddress,
            mainPhone: localMainPhone,
            secondaryPhone: localSecondaryPhone,
            clientState: localState
        }

        updateClient(clientDto).then(() => {
            toast.success('¡Cliente actualizado correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });

            additionalInfo['NOMBRE'] = localName
            additionalInfo['ESTADO'] = stateOptions.find(option => option.value === localState)?.label || ""

        }).catch((error: any) => {
            toast.error(error.message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        })
    }

    return (
        <div className="clients-info-view-container">
            {updatingClient ? (
                <div className="loading-overlay">
                    <div className="spinner">
                    </div>
                    <div className="loading-message">
                        Guardando
                    </div>
                </div>
            ) : (
                showPlants ? (<PlantsView onBack={exitPlantsView} uniqueCode={client.uniqueCode}/>) :
                    showTickets ? (
                            <NestedTableView
                                title={"TICKETS"}
                                columns={columns}
                                tickets={tickets}
                                totalPages={totalPages}
                                isLoading={isLoading}
                                page={page}
                                setPage={setPage}
                                onBack={existTicketsView}/>
                        ) :
                        showEquipments ? (<NestedEquipmentView onBack={exitEquipmentView} clientId={client.name}/>) :
                        (<>
                            <div className="clients-info-view-header">
                                <button onClick={onBack}>REGRESAR</button>
                                <div className="clients-info-view-header-title">
                                    <p>CLIENTE</p>
                                </div>
                                <span className={`material-icons-outlined icon-unselected ${
                                    !editDisabled ? "active-edit" : ""}`} onClick={() => {
                                    setEditDisabled(!editDisabled);
                                }}>
                        edit
                </span>
                                <span className="material-icons-outlined icon-unselected" onClick={handlePlantsClick}>
                        factory
                </span>
                                <span className="material-icons-outlined icon-unselected" onClick={handleTicketsClick}>
                        receipt_long
                </span>
                                <span className="material-icons-outlined icon-unselected"
                                      onClick={handleEquipmentsClick}>
                        construction
                </span>


                            </div>
                            <div className="clients-info-view-body-info">
                                <div className="client-info-attribute">
                                    <div className="client-attribute-label">CLAVE DE CLIENTE</div>
                                    <div className="value-label">{localUniqueCode}</div>
                                </div>
                                <div className="client-info-attribute">
                                    <div className="client-attribute-label">EMAIL</div>
                                    <input
                                        className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                        type="text"
                                        value={localEmail}
                                        disabled={editDisabled}
                                        onChange={(e) => setLocalEmail(e.target.value)}
                                    />
                                </div>
                                <div className="client-info-attribute">
                                    <div className="client-attribute-label">NOMBRE</div>
                                    <input
                                        className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                        type="text"
                                        value={localName}
                                        disabled={editDisabled}
                                        onChange={(e) => setLocalName(e.target.value)}
                                    />
                                </div>
                                <div className="client-info-attribute">
                                    <div className="client-attribute-label">DIRECCIÓN FISCAL</div>
                                    <input
                                        className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                        type="text"
                                        value={localTaxAddress}
                                        disabled={editDisabled}
                                        onChange={(e) => setLocalTaxAddress(e.target.value)}
                                    />
                                </div>
                                <div className="client-info-attribute">
                                    <div className="client-attribute-label">TELÉFONO PRINCIPAL</div>
                                    <input
                                        className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                        type="text"
                                        value={localMainPhone}
                                        disabled={editDisabled}
                                        onChange={(e) => setLocalMainPhone(e.target.value)}
                                    />
                                </div>
                                <div className="client-info-attribute">
                                    <div className="client-attribute-label">TELÉFONO SECUNDARIO</div>
                                    <input
                                        className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                        type="text"
                                        value={localSecondaryPhone}
                                        disabled={editDisabled}
                                        onChange={(e) => setLocalSecondaryPhone(e.target.value)}
                                    />
                                </div>
                                <div className="client-info-attribute">
                                    <div className="client-attribute-label">ESTADO</div>
                                    {editDisabled ? (
                                        <div className={`value-label ${editDisabled ? "input-disabled" : ""}`}>
                                            {stateOptions.find(option => option.value === localState)?.label || ""}
                                        </div>
                                    ) : (
                                        <select
                                            className="value-label"
                                            value={localState}
                                            onChange={(e) => setLocalState(e.target.value)}
                                        >
                                            {stateOptions.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </div>
                                {!editDisabled && (
                                    <div className="bottom-buttons">
                                        <button type="submit" className="confirm" onClick={handleClientUpdate}>
                                            Guardar
                                        </button>
                                    </div>
                                )}
                            </div>
                        </>)
            )
            }
        </div>
    )
}

export default ClientInfo;